import {
  SegmentedControl as MantineSC,
  SegmentedControlItem,
} from '@mantine/core';

import classNames from './segmentedControl.module.scss';

export type SegmentedControlProps = {
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  options: SegmentedControlItem[];
  value?: string;
};

export const SegmentedControl = ({
  className,
  defaultValue,
  disabled,
  onChange,
  options,
  value,
}: SegmentedControlProps) => {
  return (
    <MantineSC
      className={className}
      classNames={classNames}
      data={options}
      defaultValue={defaultValue}
      disabled={disabled}
      onChange={onChange}
      value={value}
      withItemsBorders={false}
    />
  );
};
